import React, { useState, useEffect } from "react";
import { Typography, Grid, Container, Box } from "@mui/material";
import api from "axios";
import { getBlockchainNodeUrl } from "../globals/const";
import { useLocation } from "react-router-dom";
import { Chart, ArcElement } from "chart.js";

const styles = {
  icon: {
    marginRight: 2,
  },
  mainContent: {
    padding: 0.25,
    paddingLeft: 0.5,
    paddingRight: 0.5,
    flexGrow: 1,
  },
  row: {
    item: true,
    container: true,
    spacing: 1,
    justify: "center",
  },
  fab: {
    position: "fixed",
    bottom: 2,
    left: 2,
  },
  fabRow: {},
  fundSelectorRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  buttonRow: {
    margin: "10px",
    display: "flex",
    justifyContent: "space-around",
  },

  chartContainer: {
    display: "flex",
    flexDirection: "row",
    height: "40vh",
    width: "15vw",
    margin: "0 auto",
  },

  pieChart: {
    flex: 0.5,
    position: "relative",
  },

  legend: {
    flex: 0.5,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: "25px",
  },

  legendItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "30px",
  },

  legendColor: {
    width: "1.5rem",
    height: "1.5rem",
    marginRight: "0.5rem",
  },

  legendLabel: {
    fontSize: "14px",
    fontWeight: "bold",
  },

  typographyContainer: {
    display: "flex",
    justifyContent: "space-between",
  },

  firstTypography: {
    marginRight: "20px",
  },

  secondTypography: {
    marginLeft: "20px",
  },

  qrCode: {
    width: "300px",
    margin: "auto",
  },
};

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

Chart.register(ArcElement);

export default function ViewHarvest() {
  const classes = styles;

  const [isLoading, setIsLoading] = useState(true);
  const [productData, setProductData] = useState({});
  const [tokenData, setTokenData] = useState({});

  let urlQuery = useQuery();
  const token_code = urlQuery.get("token_code");

  useEffect(() => {
    const loadProduct = async () => {
      await api
        .get(`${getBlockchainNodeUrl()}/get-token?token_code=${token_code}`)
        .then((res) => res.data)
        .then((data) => {
          setTokenData(data);
          const tokenAttributes = JSON.parse(data.token_attributes);
          console.log("tokenAttributes", tokenAttributes);
          console.log("tokenData", data);
          setProductData(tokenAttributes);
        })
        .catch((err) => {
          console.error("Error:", err);
        });

      setIsLoading(false);
    };

    loadProduct();
  }, [token_code]);

  if (isLoading) {
    return (
      <div>
        <Typography
          variant="h3"
          textAlign="center"
          style={{ marginTop: "10px", marginBottom: "10px" }}
        >
          Loading
        </Typography>
      </div>
    );
  }

  return (
    <>
      <Container maxWidth="sm">
        <div className={classes.mainContent}>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            {/* FundSelector */}
            <Grid container item>
              <Grid item xs>
                <Box
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-around",
                    marginTop: "20px",
                  }}
                >
                  <Typography
                    variant="h5"
                    style={{ marginTop: "10px", marginBottom: "10px" }}
                  >
                    View Harvest
                  </Typography>

                  <Typography variant="h6" mt={2}>
                    1. Harvest Details
                  </Typography>
                  <Box m={2}>
                    <Typography>
                      Token Code:
                      <a
                        href={`${getBlockchainNodeUrl()}/get-token?token_code=${token_code}`}
                        target="_blanks"
                      >
                        {tokenData.tokencode}
                      </a>
                    </Typography>
                    <Typography>Creator: {tokenData.custodian}</Typography>
                    <Typography>Owner: {tokenData.first_owner}</Typography>

                    <Typography>Commodity: {productData.crop_type}</Typography>
                    <Typography>
                      Harvest Date: {productData.harvest_date}
                    </Typography>
                    <Typography>
                      Quality at Harvest: {productData.harvest_quality}
                    </Typography>
                    <Typography>
                      Land Token:{" "}
                      <a
                        href={`/view-land/?token_code=${productData.land_token}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {productData.land_token}
                      </a>
                    </Typography>
                    <Typography>
                      Creation Transaction:
                      <a
                        href={`${getBlockchainNodeUrl()}/get-transaction?transaction_code=${
                          tokenData.parent_transaction_code
                        }`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {tokenData.parent_transaction_code}
                      </a>
                    </Typography>
                  </Box>

                  <Typography variant="h6" mt={2}>
                    2. Harvest Pictures
                  </Typography>
                  <Box m={2}>
                    <img src={"/assets/rice1.avif"} width={400} />
                    <img src={"/assets/rice2.jpeg"} width={400} />
                  </Box>

                  <Typography variant="h6" mt={2}>
                    3. Lab Quality Reports
                  </Typography>
                  <Box m={2}>
                    <Typography>Damage: 2.12%</Typography>
                    <Typography>Foreign Matter: 1.54%</Typography>
                    <Typography>Immature: 2.46%</Typography>
                    <Typography>Moisture: 9.4%</Typography>
                  </Box>

                  <Typography variant="h6" mt={2}>
                    4. Emission Details
                  </Typography>
                  <Box m={2}>
                    <Typography>
                      Total Carbon Emission: {productData.carbon_emission}10 KG
                    </Typography>
                    <Typography>
                      Crop Rotation Used:{" "}
                      {productData.crop_rotation_used ? "Yes" : "No"}
                    </Typography>
                    <Typography>
                      Drip Irrigation Used:{" "}
                      {productData.drip_irrigation_used ? "Yes" : "No"}
                    </Typography>
                    <Typography>
                      Stubble Burnt: {productData.stubble_burnt ? "Yes" : "No"}
                    </Typography>
                  </Box>

                  <Typography variant="h6" mt={2}>
                    5. QR Code
                  </Typography>
                  <img
                    src={`https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=${window.location.href}&choe=UTF-8`}
                    alt="QR code"
                    style={styles.qrCode}
                  />

                  <Typography variant="h6" mt={2}>
                    6. Claim Verifications
                  </Typography>
                  <Box m={2}>No Claims</Box>

                  {/*<div style={styles.firstTypography}>
                    <Typography variant="h6" mt={2}>1. Ingredients</Typography>
                    <ol>
                      {productData.farms ? <ViewProductMap center={productData.farms[0].polygon[0]} paths={productData.farms.map((farm) => farm.polygon)} /> : <></>}
                      {productData.ingredients ? productData.ingredients.map((ingredient, index) => {
                        return (
                          <li><a href={getBlockchainNodeUrl() + "/get-token?token_code="
                            + ingredient.ingredient_token}
                            target="_blank">
                            <Typography key={index}>{ingredient.ingredient_token}</Typography></a>
                          </li>
                        )
                      }) : <></>}
                    </ol>
                  </div>

                  <div style={styles.secondTypography}>
                    <Typography variant="h6" mt={2}>2. Emission Breakdown</Typography>
                    <div style={styles.chartContainer}>
                      <Pie data={pieChartData} options={pieChartOptions} style={styles.pieChart} />
                      <div style={styles.legend}>
                        <div style={styles.legendItem}>
                          <div style={{ ...styles.legendColor, backgroundColor: '#FF6384' }}></div>
                          <div style={styles.legendLabel}>Harvest - {roundDec(productData.emission.harvest / productData.emission.total * 100)}%</div>
                        </div>
                        <div style={styles.legendItem}>
                          <div style={{ ...styles.legendColor, backgroundColor: '#36A2EB' }}></div>
                          <div style={styles.legendLabel}>Storage - {roundDec(productData.emission.storage / productData.emission.total * 100)}%</div>
                        </div>
                        <div style={styles.legendItem}>
                          <div style={{ ...styles.legendColor, backgroundColor: '#FFCE56' }}></div>
                          <div style={styles.legendLabel}>Transport - {roundDec(productData.emission.transport / productData.emission.total * 100)}%</div>
                        </div>
                        <div style={styles.legendItem}>
                          <div style={{ ...styles.legendColor, backgroundColor: '#A020F0' }}></div>
                          <div style={styles.legendLabel}>Processing - {roundDec(productData.emission.processing / productData.emission.total * 100)}%</div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <Typography variant="h6" mt={2}>3. Blockchain History</Typography>
                  {productData.transaction_history.map((transaction) => {
                    return <Typography variant="normal" mt={2}> {transaction} {'-->'} </Typography>
                  })}
                  <Typography marginTop="10px" textAlign="center">No transportation history</Typography> */}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Container>
    </>
  );
}
